import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { InputMaskModule } from 'primeng/inputmask';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from '@modules/util/util.module';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FileUploadModule } from 'primeng/fileupload';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

import { CodigoEquipoComponent } from './codigo-equipo/codigo-equipo.component';
import { ColaboradorComponent } from './colaborador/colaborador.component';
import { DepartamentosComponent } from './departamentos/departamentos.component';
import { EquipoPatronComponent } from './equipo-patron/equipo-patron.component';
import { MarcaComponent } from './marca/marca.component';
import { ProveedorComponent } from './proveedor/proveedor.component';
import { MagnitudesComponent } from './magnitudes/magnitudes.component';
import { UnidadComponent } from './unidad/unidad.component';
import { FormularioCodigoEquipoComponent } from './codigo-equipo/formulario-codigo-equipo/formulario-codigo-equipo.component';
import { FormularioCodigoEquipoCaracteristicaComponent } from './codigo-equipo/formulario-codigo-equipo-caracteristica/formulario-codigo-equipo-caracteristica.component';
import { FormularioCodigoEquipoCaracteristicaEditarComponent } from './codigo-equipo/formulario-codigo-equipo-caracteristica-editar/formulario-codigo-equipo-caracteristica-editar.component';
import { FormularioColaboradorComponent } from './colaborador/formulario-colaborador/formulario-colaborador.component';
import { FormularioDepartamentoComponent } from './departamentos/formulario-departamento/formulario-departamento.component';
import { FormularioEquipoPatronComponent } from './equipo-patron/formulario-equipo-patron/formulario-equipo-patron.component';
import { FormularioMagnitudesComponent } from './magnitudes/formulario-magnitudes/formulario-magnitudes.component';
import { FormularioMarcaComponent } from './marca/formulario-marca/formulario-marca.component';
import { FormularioProveedorComponent } from './proveedor/formulario-proveedor/formulario-proveedor.component';
import { FormularioUnidadComponent } from './unidad/formulario-unidad/formulario-unidad.component';
import { EquipoComponent } from './equipo/equipo.component';
import { FormularioEquipoComponent } from './equipo/formulario-equipo/formulario-equipo.component';
import { FormularioAlcanceComponent } from './equipo/formulario-alcance/formulario-alcance.component';
import { MenuGuard } from '@guards/menu.guard';
import { FormatosComponent } from './formatos/formatos.component';
import { FormularioFormatosComponent } from './formatos/formulario-formatos/formulario-formatos.component';

@NgModule({
  declarations: [
    DepartamentosComponent,
    ColaboradorComponent,
    FormularioColaboradorComponent,
    FormularioDepartamentoComponent,
    ProveedorComponent,
    FormularioProveedorComponent,
    FormularioMagnitudesComponent,
    MagnitudesComponent,
    UnidadComponent,
    FormularioUnidadComponent,
    MarcaComponent,
    FormularioMarcaComponent,
    CodigoEquipoComponent,
    FormularioCodigoEquipoComponent,
    FormularioCodigoEquipoCaracteristicaComponent,
    FormularioCodigoEquipoCaracteristicaEditarComponent,
    EquipoPatronComponent,
    FormularioEquipoPatronComponent,
    EquipoComponent,
    FormularioEquipoComponent,
    FormularioAlcanceComponent,
    FormatosComponent,
    FormularioFormatosComponent
  ],
  imports: [
    CommonModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSelectModule,
    InputMaskModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatRadioModule,
    MatDatepickerModule,
    DropdownModule,
    NgxDropzoneModule,
    UtilModule,
    InputSwitchModule,
    InputTextModule,
    FileUploadModule,
    ButtonModule,
    RouterModule.forChild([
      {
        path:'departamentos',
        component: DepartamentosComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'colaboradores',
        component: ColaboradorComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'proveedores',
        component: ProveedorComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'magnitud',
        component: MagnitudesComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'unidad',
        component: UnidadComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'marca',
        component: MarcaComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'codigoEquipo',
        component: CodigoEquipoComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'equipo',
        component: EquipoComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'patron',
        component: EquipoPatronComponent,
        canActivate: [MenuGuard]
      },
      {
        path:'formato',
        component: FormatosComponent,
        canActivate: [MenuGuard]
      }
    ])
  ]
})
export class CatalogosModule { }
